module.exports = __webpack_public_path__ + "img/default-avatar.d05d5ecf.png";